exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1734895a] .el-dialog {\n  width: 4.166667rem;\n}\nvideo[data-v-1734895a] {\n  display: block;\n  margin: 0.104167rem auto;\n  max-width: 90%;\n}", ""]);

// exports
